<template>
  <Modal v-model="modal" width="1000" :styles="{top: fromListing ? '20px' : '100px'}" :title="$t('key1000078')">
    <div class="docx">
      <component :is="switchComponent"></component>
    </div>
    <template #footer>
      <Button @click="modal=false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import Mixin from '@/components/mixin/common_mixin';
import privacyPolicyCN from "@/views/shopping/common/privacyPolicyCN";
import privacyPolicyUS from "@/views/shopping/common/privacyPolicyUS";

export default {
  name: 'privacyPolicy',
  mixins: [Mixin],
  data() {
    return {
      modal: false
    };
  },
  components: {
    privacyPolicyCN,
    privacyPolicyUS
  },
  computed: {
    fromListing() {
      return this.$store.state.fromListing;
    },
    switchComponent() {
      let component = this.languagesVal === 'zh-CN' ? privacyPolicyCN : privacyPolicyUS;
      return component;
    }
  },
};
</script>

<style scoped lang="less">
.docx {
  padding: 38px;
  background-color: #ffffff;
  color: #000;
  max-height: 600px;
  overflow-y: auto;
}
</style>
